import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { di } from 'react-magnetic-di';
import { useExternalMessages, useHydratedDeprecations } from '../../state';
export var useEditorViewHasWarnings = function useEditorViewHasWarnings() {
  var _useHydratedDeprecati = useHydratedDeprecations(),
    _useHydratedDeprecati2 = _slicedToArray(_useHydratedDeprecati, 1),
    hydratedDeprecations = _useHydratedDeprecati2[0];
  var _useExternalMessages = useExternalMessages(),
    _useExternalMessages2 = _slicedToArray(_useExternalMessages, 1),
    externalWarnings = _useExternalMessages2[0].warnings;
  return hydratedDeprecations.length > 0 || externalWarnings.length > 0;
};